import React, { useState } from 'react';
import { FaFlask, FaMicroscope, FaBook, FaGraduationCap, FaSeedling, FaHeartbeat, FaAtom, FaChartLine, FaCheckCircle, FaLaptop, FaClock, FaTrophy, FaChevronDown, FaChevronUp, FaUniversity, FaAward, FaUserGraduate, FaSearch, FaDna, FaLeaf } from 'react-icons/fa';

const ResearchAcademicPage = () => {
  const [expandedOrg, setExpandedOrg] = useState(null);
  const [expandedSubject, setExpandedSubject] = useState(null);
  const [expandedExam, setExpandedExam] = useState(null);

  const organizations = [
    {
      id: 'csir',
      name: 'CSIR (Council of Scientific & Industrial Research)',
      fullName: 'Council of Scientific and Industrial Research',
      icon: <FaFlask />,
      established: '1942',
      ministry: 'Ministry of Science & Technology',
      description: 'India\'s premier R&D organization with 37 national laboratories',
      exams: [
        {
          name: 'CSIR NET (National Eligibility Test)',
          purpose: 'Lectureship (LS) and Junior Research Fellowship (JRF)',
          eligibility: 'M.Sc. or equivalent with 55% marks (50% for reserved)',
          ageLimit: 'No age limit for LS, 28 years for JRF (relaxation for reserved)',
          fellowship: 'JRF: ₹31,000/month, SRF: ₹35,000/month',
          subjects: ['Chemical Sciences', 'Earth, Atmospheric, Ocean and Planetary Sciences', 'Life Sciences', 'Mathematical Sciences', 'Physical Sciences'],
          pattern: 'Single Paper (3 hours) - 150 Questions (MCQ)',
          examFrequency: 'Twice a year (June & December)'
        }
      ],
      fellowships: [
        { name: 'Junior Research Fellow (JRF)', amount: '₹31,000/month + HRA', duration: 'First 2 years' },
        { name: 'Senior Research Fellow (SRF)', amount: '₹35,000/month + HRA', duration: 'Next 3 years' },
        { name: 'Research Associate (RA)', amount: '₹54,000/month', duration: 'Post-PhD' }
      ],
      laboratories: ['CSIR-NCL Pune', 'CSIR-CDRI Lucknow', 'CSIR-IICT Hyderabad', 'CSIR-IGIB Delhi', 'CSIR-CEERI Pilani', 'CSIR-IMMT Bhubaneswar', 'CSIR-IIP Dehradun', 'CSIR-CCMB Hyderabad', 'CSIR-NEERI Nagpur', 'CSIR-NGRI Hyderabad'],
      careerPath: 'JRF → SRF → Research Associate → Scientist → Senior Scientist → Principal Scientist → Chief Scientist'
    },
    {
      id: 'ugc',
      name: 'UGC (University Grants Commission)',
      fullName: 'University Grants Commission',
      icon: <FaUniversity />,
      established: '1956',
      ministry: 'Ministry of Education',
      description: 'Statutory body for coordination, determination and maintenance of standards of university education',
      exams: [
        {
          name: 'UGC NET (National Eligibility Test)',
          purpose: 'Assistant Professor and JRF in Indian Universities/Colleges',
          eligibility: 'Master\'s Degree with 55% marks (50% for reserved)',
          ageLimit: 'No age limit for Assistant Professor, 30 years for JRF (relaxation available)',
          fellowship: 'JRF: ₹31,000/month, SRF: ₹35,000/month',
          subjects: ['81 subjects covering Humanities, Social Sciences, Sciences, Languages, Commerce, etc.'],
          pattern: 'Two Papers - Paper I (General) 50 Questions, Paper II (Subject) 100 Questions',
          examFrequency: 'Twice a year'
        }
      ],
      fellowships: [
        { name: 'Junior Research Fellowship (JRF)', amount: '₹31,000/month + HRA', duration: 'First 2 years' },
        { name: 'Senior Research Fellowship (SRF)', amount: '₹35,000/month + HRA', duration: 'Next 3 years' },
        { name: 'Rajiv Gandhi National Fellowship', amount: '₹31,000-35,000/month', duration: 'For SC/ST students' },
        { name: 'Maulana Azad National Fellowship', amount: '₹31,000-35,000/month', duration: 'For minority students' }
      ],
      benefits: [
        'Eligibility for Assistant Professor positions',
        'JRF for pursuing PhD with financial support',
        'National level recognition',
        'Exemption from entrance tests in many universities',
        'Career advancement in academia'
      ],
      careerPath: 'NET Qualified → Assistant Professor → Associate Professor → Professor → Dean → Vice Chancellor'
    },
    {
      id: 'icar',
      name: 'ICAR (Indian Council of Agricultural Research)',
      fullName: 'Indian Council of Agricultural Research',
      icon: <FaSeedling />,
      established: '1929',
      ministry: 'Ministry of Agriculture & Farmers Welfare',
      description: 'Apex body for coordinating, guiding and managing research and education in agriculture',
      exams: [
        {
          name: 'ICAR AIEEA (All India Entrance Examination for Admission)',
          purpose: 'Admission to UG and PG programs in Agricultural Universities',
          eligibility: '10+2 for UG, B.Sc. Agriculture for PG',
          ageLimit: 'As per university norms',
          fellowship: 'N/A (Admission exam)',
          subjects: ['Physics', 'Chemistry', 'Biology/Agriculture', 'Mathematics'],
          pattern: 'Online CBT - Multiple Choice Questions',
          examFrequency: 'Once a year'
        },
        {
          name: 'ICAR NET (National Eligibility Test)',
          purpose: 'ARS (Agricultural Research Service) and Lectureship',
          eligibility: 'M.Sc. in Agriculture/Allied Sciences',
          ageLimit: '21-32 years for ARS',
          fellowship: 'ARS Scientist: ₹56,100 - ₹1,77,500/month',
          subjects: ['Agronomy', 'Horticulture', 'Plant Pathology', 'Entomology', 'Soil Science', 'Agricultural Economics', 'Animal Science', 'Veterinary Science', 'Fisheries', 'Forestry'],
          pattern: 'Paper I (General) + Paper II (Subject) + Paper III (Subject)',
          examFrequency: 'Once a year'
        }
      ],
      fellowships: [
        { name: 'Junior Research Fellowship', amount: '₹31,000/month + HRA', duration: 'First 2 years' },
        { name: 'Senior Research Fellowship', amount: '₹35,000/month + HRA', duration: 'Next 3 years' },
        { name: 'ARS Scientist', amount: '₹56,100 - ₹1,77,500/month', duration: 'Career post' },
        { name: 'IARI PhD Fellowship', amount: '₹25,000-28,000/month', duration: 'PhD duration' }
      ],
      institutes: ['IARI Delhi', 'IVRI Bareilly', 'NBPGR Delhi', 'CIFE Mumbai', 'NRCPB New Delhi', 'CIFA Bhubaneswar', 'NIANP Bengaluru', 'CIRCOT Mumbai'],
      careerPath: 'NET JRF → PhD → Scientist → Senior Scientist → Principal Scientist → Head of Division → Director'
    },
    {
      id: 'icmr',
      name: 'ICMR (Indian Council of Medical Research)',
      fullName: 'Indian Council of Medical Research',
      icon: <FaHeartbeat />,
      established: '1911',
      ministry: 'Ministry of Health & Family Welfare',
      description: 'Apex body in India for formulation, coordination and promotion of biomedical research',
      exams: [
        {
          name: 'ICMR JRF Exam',
          purpose: 'Junior Research Fellowship in Biomedical Sciences',
          eligibility: 'M.Sc. in Life Sciences/Medical Sciences with 55%',
          ageLimit: '28 years (relaxation for reserved categories)',
          fellowship: 'JRF: ₹31,000/month, SRF: ₹35,000/month',
          subjects: ['Life Sciences', 'Biomedical Sciences', 'Clinical Sciences', 'Public Health', 'Biotechnology', 'Microbiology', 'Biochemistry'],
          pattern: 'Online CBT - Multiple Choice Questions',
          examFrequency: 'Once a year'
        }
      ],
      fellowships: [
        { name: 'Junior Research Fellowship (JRF)', amount: '₹31,000/month + HRA', duration: 'First 2 years' },
        { name: 'Senior Research Fellowship (SRF)', amount: '₹35,000/month + HRA', duration: 'Next 3 years' },
        { name: 'Research Associateship', amount: '₹54,000/month + HRA', duration: 'Post-doctoral' },
        { name: 'MD/MS Fellowship', amount: '₹60,000/month', duration: '3 years' }
      ],
      institutes: ['NIIH Mumbai', 'NIRTH Jabalpur', 'NICED Kolkata', 'RMRC Bhubaneswar', 'NIOH Ahmedabad', 'VCRC Puducherry', 'NITM Chennai', 'NIN Hyderabad'],
      researchAreas: ['Communicable Diseases', 'Non-Communicable Diseases', 'Reproductive Health', 'Nutrition', 'Environmental Health', 'Clinical Research', 'Traditional Medicine', 'Health Systems Research'],
      careerPath: 'JRF → SRF → Research Associate → Scientist B → Scientist C → Scientist D → Scientist E → Scientist G'
    }
  ];

  const subjectCategories = [
    {
      category: 'Chemical Sciences (CSIR NET)',
      icon: <FaFlask />,
      subjects: [
        'Inorganic Chemistry',
        'Organic Chemistry',
        'Physical Chemistry',
        'Analytical Chemistry',
        'Material Chemistry',
        'Medicinal Chemistry',
        'Environmental Chemistry',
        'Polymer Chemistry'
      ],
      syllabus: 'Atomic structure, Bonding, Chemical equilibrium, Electrochemistry, Organic reactions, Spectroscopy, Coordination chemistry, Thermodynamics'
    },
    {
      category: 'Life Sciences (CSIR/UGC NET)',
      icon: <FaDna />,
      subjects: [
        'Molecular Biology',
        'Cell Biology',
        'Genetics',
        'Biochemistry',
        'Microbiology',
        'Immunology',
        'Biotechnology',
        'Bioinformatics',
        'Plant Sciences',
        'Animal Sciences',
        'Ecology & Evolution'
      ],
      syllabus: 'Cell structure, Biomolecules, Metabolism, Molecular genetics, Recombinant DNA technology, Enzymology, Immunology, Biodiversity'
    },
    {
      category: 'Physical Sciences (CSIR NET)',
      icon: <FaAtom />,
      subjects: [
        'Classical Mechanics',
        'Quantum Mechanics',
        'Electromagnetic Theory',
        'Thermodynamics & Statistical Mechanics',
        'Atomic & Molecular Physics',
        'Nuclear & Particle Physics',
        'Solid State Physics',
        'Electronics'
      ],
      syllabus: 'Newton\'s laws, Wave mechanics, Maxwell equations, Quantum theory, Relativity, Solid state concepts, Nuclear physics'
    },
    {
      category: 'Mathematical Sciences (CSIR NET)',
      icon: <FaChartLine />,
      subjects: [
        'Analysis',
        'Linear Algebra',
        'Complex Analysis',
        'Topology',
        'Ordinary Differential Equations',
        'Partial Differential Equations',
        'Numerical Analysis',
        'Discrete Mathematics'
      ],
      syllabus: 'Calculus, Abstract algebra, Real analysis, Complex analysis, Topology, Differential equations, Probability & Statistics'
    },
    {
      category: 'Earth Sciences (CSIR NET)',
      icon: <FaLeaf />,
      subjects: [
        'Geology',
        'Geophysics',
        'Meteorology',
        'Oceanography',
        'Atmospheric Sciences',
        'Paleontology',
        'Environmental Sciences'
      ],
      syllabus: 'Earth structure, Plate tectonics, Mineralogy, Petrology, Geochemistry, Climate systems, Ocean dynamics'
    },
    {
      category: 'Agricultural Sciences (ICAR NET)',
      icon: <FaSeedling />,
      subjects: [
        'Agronomy',
        'Horticulture',
        'Soil Science',
        'Plant Pathology',
        'Entomology',
        'Agricultural Economics',
        'Agricultural Extension',
        'Genetics & Plant Breeding',
        'Agricultural Engineering'
      ],
      syllabus: 'Crop production, Soil fertility, Plant diseases, Pest management, Farm management, Breeding techniques'
    },
    {
      category: 'Humanities & Social Sciences (UGC NET)',
      icon: <FaBook />,
      subjects: [
        'Economics',
        'Political Science',
        'History',
        'Sociology',
        'Psychology',
        'Philosophy',
        'English Literature',
        'Hindi Literature',
        'Education',
        'Commerce',
        'Management',
        'Library Science'
      ],
      syllabus: 'Varies by subject - Theories, Concepts, Historical developments, Contemporary issues'
    }
  ];

  const examPattern = {
    csirNet: {
      name: 'CSIR NET Exam Pattern',
      duration: '3 Hours',
      totalMarks: '200 Marks',
      sections: [
        { part: 'Part A', questions: '20', marks: '40 (2 marks each)', description: 'General Aptitude (Compulsory for all subjects)' },
        { part: 'Part B', questions: '40', marks: '80 (2 marks each)', description: 'Subject-related MCQs' },
        { part: 'Part C', questions: '60', marks: '160 (Variable marking)', description: 'Higher-level subject questions' }
      ],
      note: 'Part A: Logical reasoning, Graphical analysis, Numerical ability, Data interpretation'
    },
    ugcNet: {
      name: 'UGC NET Exam Pattern',
      duration: '3 Hours',
      totalMarks: '300 Marks',
      sections: [
        { part: 'Paper I', questions: '50', marks: '100 (2 marks each)', description: 'Teaching & Research Aptitude' },
        { part: 'Paper II', questions: '100', marks: '200 (2 marks each)', description: 'Subject-specific questions' }
      ],
      note: 'Paper I: Teaching aptitude, Research aptitude, Comprehension, Communication, Reasoning, Data interpretation'
    },
    icarNet: {
      name: 'ICAR NET Exam Pattern',
      duration: '2.5 Hours each',
      totalMarks: '360 Marks',
      sections: [
        { part: 'Paper I', questions: '60', marks: '120', description: 'Agriculture & allied sciences general' },
        { part: 'Paper II', questions: '60', marks: '120', description: 'Subject-specific' },
        { part: 'Paper III', questions: '60', marks: '120', description: 'Advanced subject questions' }
      ],
      note: 'All three papers are compulsory for ARS. Only Paper I & II for Lectureship'
    },
    icmrJrf: {
      name: 'ICMR JRF Exam Pattern',
      duration: '2 Hours',
      totalMarks: '200 Marks',
      sections: [
        { part: 'Section A', questions: '60', marks: '120', description: 'General Biomedical Sciences' },
        { part: 'Section B', questions: '40', marks: '80', description: 'Subject-specific questions' }
      ],
      note: 'Negative marking: 0.25 marks for each wrong answer'
    }
  };

  const preparationStrategy = [
    {
      phase: 'Foundation Phase (3 months)',
      duration: '3 Months',
      activities: [
        'Complete syllabus coverage',
        'Standard textbook reading',
        'Concept building and clarity',
        'Basic problem-solving practice',
        'Note-making for quick revision',
        'Understanding exam pattern'
      ]
    },
    {
      phase: 'Practice Phase (3 months)',
      duration: '3 Months',
      activities: [
        'Previous year question papers',
        'Topic-wise practice',
        'Speed and accuracy improvement',
        'Shortcut techniques learning',
        'Weekly mock tests',
        'Error analysis and improvement'
      ]
    },
    {
      phase: 'Revision Phase (2 months)',
      duration: '2 Months',
      activities: [
        'Complete syllabus revision',
        'Formula and theory sheets',
        'Full-length mock tests',
        'Time management practice',
        'Weak area strengthening',
        'Current affairs for GA'
      ]
    },
    {
      phase: 'Final Phase (1 month)',
      duration: '1 Month',
      activities: [
        'Quick revision of all topics',
        'Daily mock tests',
        'Previous year analysis',
        'Strategy finalization',
        'Stress management',
        'Last-minute tips review'
      ]
    }
  ];

  const careerOptions = [
    {
      path: 'Academic Career',
      icon: <FaGraduationCap />,
      positions: ['Assistant Professor', 'Associate Professor', 'Professor', 'Dean', 'Vice-Chancellor'],
      salary: '₹57,700 - ₹2,10,000/month (as per 7th CPC)',
      growth: 'Teaching in universities and colleges with research opportunities'
    },
    {
      path: 'Research Career',
      icon: <FaMicroscope />,
      positions: ['Junior Research Fellow', 'Senior Research Fellow', 'Research Associate', 'Scientist', 'Principal Scientist'],
      salary: '₹31,000 - ₹2,00,000/month',
      growth: 'Research in CSIR/ICAR/ICMR labs and institutes'
    },
    {
      path: 'Industry Career',
      icon: <FaFlask />,
      positions: ['Research Scientist', 'R&D Manager', 'Quality Control Head', 'Technical Consultant'],
      salary: '₹40,000 - ₹1,50,000/month',
      growth: 'Pharmaceutical, biotechnology, chemical, and food industries'
    },
    {
      path: 'Government Jobs',
      icon: <FaUniversity />,
      positions: ['Scientific Officer', 'Technical Officer', 'Lab Superintendent', 'Research Officer'],
      salary: '₹35,000 - ₹1,20,000/month',
      growth: 'Various government research organizations and regulatory bodies'
    }
  ];

  const benefits = [
    'Prestigious fellowship for pursuing PhD',
    'Financial independence during research',
    'Access to world-class research facilities',
    'Opportunity to work with renowned scientists',
    'Eligibility for academic positions nationwide',
    'Conference participation and travel support',
    'Publication opportunities in reputed journals',
    'International collaboration possibilities',
    'HRA and contingency allowances',
    'Medical benefits',
    'Career advancement in academia/research',
    'Contribution to national development',
    'Post-doctoral opportunities',
    'Patent filing support',
    'Skill development and training',
    'Networking with research community'
  ];

  const features = [
    {
      icon: <FaBook />,
      title: 'Subject Expert Faculty',
      description: 'Learn from PhD holders and experienced NET qualified teachers'
    },
    {
      icon: <FaLaptop />,
      title: 'Online Test Series',
      description: 'Unlimited mock tests matching actual exam pattern and difficulty'
    },
    {
      icon: <FaMicroscope />,
      title: 'Research Methodology',
      description: 'Special classes on research aptitude and methodology'
    },
    {
      icon: <FaClock />,
      title: 'Flexible Learning',
      description: 'Online and offline modes with recorded lectures'
    },
    {
      icon: <FaTrophy />,
      title: 'Study Material',
      description: 'Comprehensive notes, books, and reference materials'
    },
    {
      icon: <FaAward />,
      title: 'Interview Guidance',
      description: 'Preparation for research interviews and PhD admissions'
    }
  ];

  const toggleOrg = (id) => {
    setExpandedOrg(expandedOrg === id ? null : id);
  };

  const toggleSubject = (category) => {
    setExpandedSubject(expandedSubject === category ? null : category);
  };

  const toggleExam = (name) => {
    setExpandedExam(expandedExam === name ? null : name);
  };

  return (
    <div className="min-vh-100" style={{ backgroundColor: '#f8f9fa' }}>
      {/* Hero Section */}
      <div className="text-white py-5 my-5" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <h1 className="display-4 fw-bold mb-3">Research & Academic Sector Training</h1>
              <p className="lead mb-4">
                Comprehensive preparation for CSIR NET, UGC NET, ICAR NET, and ICMR JRF. Build your career in research and academia with prestigious fellowships and academic positions.
              </p>
              <button className="btn btn-light btn-lg px-4 me-3">Start Preparation</button>
              <button className="btn btn-outline-light btn-lg px-4">Download Syllabus</button>
            </div>
            <div className="col-lg-4 text-center">
              <FaMicroscope size={150} className="opacity-75" />
            </div>
          </div>
        </div>
      </div>

      {/* Subject Categories */}
      <div className="bg-white py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">Subject-wise Coverage</h2>
          <div className="row">
            <div className="col-9 mx-auto">
              {subjectCategories.map((category, idx) => (
                <div key={idx} className="card mb-3 border-0 shadow-sm">
                  <div 
                    className="card-header d-flex justify-content-between align-items-center"
                    onClick={() => toggleSubject(category.category)}
                    style={{ cursor: 'pointer', backgroundColor: '#f8f9fa' }}
                  >
                    <div className="d-flex align-items-center">
                      <div className="text-primary me-3" style={{ fontSize: '1.5rem' }}>
                        {category.icon}
                      </div>
                      <h5 className="mb-0 fw-bold">{category.category}</h5>
                    </div>
                    {expandedSubject === category.category ? <FaChevronUp /> : <FaChevronDown />}
                  </div>
                  {expandedSubject === category.category && (
                    <div className="card-body">
                      <h6 className="fw-bold mb-3">Subjects Covered:</h6>
                      <div className="d-flex flex-wrap gap-2 mb-4">
                        {category.subjects.map((subject, sIdx) => (
                          <span key={sIdx} className="badge bg-primary">{subject}</span>
                        ))}
                      </div>
                      <h6 className="fw-bold mb-2">Key Topics:</h6>
                      <p className="text-muted">{category.syllabus}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Exam Patterns */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Examination Patterns</h2>
        <div className="row g-4 col-12 mx-auto">
          {Object.values(examPattern).map((pattern, idx) => (
            <div key={idx} className="col-lg-6">
              <div className="card border-0 shadow h-100">
                <div className="card-header bg-gradient text-dark" style={{ background: `linear-gradient(135deg, ${['#667eea', '#f093fb', '#4facfe', '#43e97b'][idx]} 0%, ${['#764ba2', '#f5576c', '#00f2fe', '#38f9d7'][idx]} 100%)` }}>
                  <h5 className="mb-1 fw-bold">{pattern.name}</h5>
                  <small>Duration: {pattern.duration} | Total Marks: {pattern.totalMarks}</small>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-sm">
                      <thead className="table-light">
                        <tr>
                          <th>Section</th>
                          <th>Questions</th>
                          <th>Marks</th>
                          <th>Description</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pattern.sections.map((section, sIdx) => (
                          <tr key={sIdx}>
                            <td className="fw-semibold">{section.part}</td>
                            <td>{section.questions}</td>
                            <td className="text-success">{section.marks}</td>
                            <td><small>{section.description}</small></td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="alert alert-info mt-3 mb-0">
                    <small><strong>Note:</strong> {pattern.note}</small>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Preparation Strategy */}
      <div className="bg-light py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">9-Month Preparation Strategy</h2>
          <div className="row g-4">
            {preparationStrategy.map((phase, idx) => (
              <div key={idx} className="col-md-6">
                <div className="card border-0 shadow h-100">
                  <div className="card-header bg-primary text-white">
                    <h5 className="mb-1 fw-bold">{phase.phase}</h5>
                    <small>Duration: {phase.duration}</small>
                  </div>
                  <div className="card-body">
                    <h6 className="fw-bold mb-3">Key Activities:</h6>
                    <ul className="list-unstyled">
                      {phase.activities.map((activity, aIdx) => (
                        <li key={aIdx} className="mb-2">
                          <FaCheckCircle className="text-success me-2" />
                          {activity}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Career Options */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Career Paths After NET/JRF</h2>
        <div className="row g-4">
          {careerOptions.map((career, idx) => (
            <div key={idx} className="col-md-6">
              <div className="card border-0 shadow h-100">
                <div className="card-body p-4">
                  <div className="text-primary mb-3" style={{ fontSize: '2.5rem' }}>
                    {career.icon}
                  </div>
                  <h5 className="fw-bold mb-3">{career.path}</h5>
                  <p className="mb-3"><strong>Positions:</strong></p>
                  <div className="d-flex flex-wrap gap-2 mb-3">
                    {career.positions.map((position, pIdx) => (
                      <span key={pIdx} className="badge bg-info">{position}</span>
                    ))}
                  </div>
                  <p className="mb-2"><strong>Salary Range:</strong></p>
                  <h6 className="text-success mb-3">{career.salary}</h6>
                  <p className="text-muted mb-0"><strong>Growth:</strong> {career.growth}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Benefits */}
      <div className="bg-white py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">Benefits of Research Fellowship</h2>
          <div className="row g-3">
            {benefits.map((benefit, idx) => (
              <div key={idx} className="col-md-6">
                <div className="card border-0 shadow-sm h-100">
                  <div className="card-body d-flex align-items-center p-3">
                    <FaCheckCircle className="text-success me-3 flex-shrink-0" size={20} />
                    <p className="mb-0">{benefit}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Top Research Institutes */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Top Research Institutes in India</h2>
        <div className="row g-3">
          {[
            { name: 'Indian Institute of Science (IISc) Bangalore', type: 'Multidisciplinary' },
            { name: 'Tata Institute of Fundamental Research (TIFR) Mumbai', type: 'Basic Sciences' },
            { name: 'National Centre for Biological Sciences (NCBS) Bangalore', type: 'Life Sciences' },
            { name: 'Centre for Cellular & Molecular Biology (CCMB) Hyderabad', type: 'Biology' },
            { name: 'Indian Agricultural Research Institute (IARI) Delhi', type: 'Agriculture' },
            { name: 'National Institute of Immunology (NII) Delhi', type: 'Immunology' },
            { name: 'National Chemical Laboratory (NCL) Pune', type: 'Chemistry' },
            { name: 'National Institute of Oceanography (NIO) Goa', type: 'Ocean Sciences' },
            { name: 'Indian Institute of Tropical Meteorology (IITM) Pune', type: 'Atmospheric Sciences' },
            { name: 'National Institute of Nutrition (NIN) Hyderabad', type: 'Nutrition' },
            { name: 'Central Drug Research Institute (CDRI) Lucknow', type: 'Pharmaceutical' },
            { name: 'National Institute of Plant Genome Research (NIPGR) Delhi', type: 'Plant Sciences' }
          ].map((institute, idx) => (
            <div key={idx} className="col-md-6">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body p-3">
                  <div className="d-flex align-items-center">
                    <FaUniversity className="text-primary me-3 flex-shrink-0" size={28} />
                    <div>
                      <h6 className="mb-1 fw-bold">{institute.name}</h6>
                      <small className="text-muted">Specialization: {institute.type}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Preparation Tips */}
      <div className="bg-light py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">Subject-wise Preparation Tips</h2>
          <div className="row g-4 col-10 mx-auto">
            <div className="col-md-6">
              <div className="card border-success h-100">
                <div className="card-header bg-success text-white">
                  <h5 className="mb-0">For Science Subjects</h5>
                </div>
                <div className="card-body">
                  <ul className="list-unstyled">
                    <li className="mb-3">
                      <strong>Standard Books:</strong> Follow NCERT (11th, 12th) and standard UG/PG textbooks
                    </li>
                    <li className="mb-3">
                      <strong>Conceptual Clarity:</strong> Focus on understanding concepts rather than rote learning
                    </li>
                    <li className="mb-3">
                      <strong>Numerical Practice:</strong> Solve numerical problems daily for Physics, Chemistry
                    </li>
                    <li className="mb-3">
                      <strong>Diagrams:</strong> Practice drawing and labeling diagrams for Biology
                    </li>
                    <li className="mb-3">
                      <strong>Current Research:</strong> Read latest research papers and scientific journals
                    </li>
                    <li className="mb-3">
                      <strong>Mock Tests:</strong> Take at least 30+ full-length mock tests
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card border-info h-100">
                <div className="card-header bg-info text-white">
                  <h5 className="mb-0">For Humanities & Social Sciences</h5>
                </div>
                <div className="card-body">
                  <ul className="list-unstyled">
                    <li className="mb-3">
                      <strong>Theory Understanding:</strong> Develop deep understanding of theories and concepts
                    </li>
                    <li className="mb-3">
                      <strong>Note Making:</strong> Create comprehensive notes for quick revision
                    </li>
                    <li className="mb-3">
                      <strong>Current Affairs:</strong> Stay updated with contemporary issues and debates
                    </li>
                    <li className="mb-3">
                      <strong>Critical Thinking:</strong> Develop analytical and critical thinking abilities
                    </li>
                    <li className="mb-3">
                      <strong>Answer Writing:</strong> Practice writing structured answers
                    </li>
                    <li className="mb-3">
                      <strong>Previous Papers:</strong> Analyze last 10 years question papers thoroughly
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Important Books */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Recommended Study Materials</h2>
        <div className="row g-4 col-10 mx-auto">
          <div className="col-md-4">
            <div className="card border-0 shadow h-100">
              <div className="card-header bg-primary text-white">
                <h5 className="mb-0">Life Sciences</h5>
              </div>
              <div className="card-body">
                <ul className="list-unstyled small">
                  <li className="mb-2">📚 Cell Biology - De Robertis</li>
                  <li className="mb-2">📚 Molecular Biology - Watson</li>
                  <li className="mb-2">📚 Biochemistry - Stryer/Lehninger</li>
                  <li className="mb-2">📚 Genetics - Strickberger</li>
                  <li className="mb-2">📚 Immunology - Roitt</li>
                  <li className="mb-2">📚 Microbiology - Prescott</li>
                  <li className="mb-2">📚 Plant Physiology - Taiz & Zeiger</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card border-0 shadow h-100">
              <div className="card-header bg-success text-white">
                <h5 className="mb-0">Chemical Sciences</h5>
              </div>
              <div className="card-body">
                <ul className="list-unstyled small">
                  <li className="mb-2">📚 Physical Chemistry - Atkins</li>
                  <li className="mb-2">📚 Organic Chemistry - Morrison & Boyd</li>
                  <li className="mb-2">📚 Inorganic Chemistry - JD Lee</li>
                  <li className="mb-2">📚 Spectroscopy - Kalsi</li>
                  <li className="mb-2">📚 Analytical Chemistry - Skoog</li>
                  <li className="mb-2">📚 Organic Reactions - Clayden</li>
                  <li className="mb-2">📚 Coordination Chemistry - Miessler</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card border-0 shadow h-100">
              <div className="card-header bg-info text-white">
                <h5 className="mb-0">Physical Sciences</h5>
              </div>
              <div className="card-body">
                <ul className="list-unstyled small">
                  <li className="mb-2">📚 Classical Mechanics - Goldstein</li>
                  <li className="mb-2">📚 Quantum Mechanics - Griffiths</li>
                  <li className="mb-2">📚 Electrodynamics - Griffiths</li>
                  <li className="mb-2">📚 Solid State Physics - Kittel</li>
                  <li className="mb-2">📚 Nuclear Physics - Krane</li>
                  <li className="mb-2">📚 Statistical Mechanics - Pathria</li>
                  <li className="mb-2">📚 Electronics - Millman & Halkias</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Features */}
      <div className="bg-white py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">Why Choose Our Training?</h2>
          <div className="row g-4 col-9 mx-auto">
            {features.map((feature, idx) => (
              <div key={idx} className="col-md-4">
                <div className="card border-0 shadow-sm h-100 text-center p-4">
                  <div className="text-primary mb-3" style={{ fontSize: '3rem' }}>
                    {feature.icon}
                  </div>
                  <h5 className="fw-bold mb-3">{feature.title}</h5>
                  <p className="text-muted">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Fellowship Comparison */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Fellowship Comparison</h2>
        <div className="row g-4 col-10 mx-auto">
          <div className="col-md-3">
            <div className="card border-0 shadow text-center p-4">
              <FaFlask size={50} className="text-primary mx-auto mb-3" />
              <h5 className="fw-bold">CSIR JRF</h5>
              <h3 className="text-success mb-2">₹31,000</h3>
              <p className="text-muted small">Per Month (First 2 years)</p>
              <hr />
              <p className="small mb-0">For Science subjects</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-0 shadow text-center p-4">
              <FaUniversity size={50} className="text-success mx-auto mb-3" />
              <h5 className="fw-bold">UGC JRF</h5>
              <h3 className="text-success mb-2">₹31,000</h3>
              <p className="text-muted small">Per Month (First 2 years)</p>
              <hr />
              <p className="small mb-0">All subjects (81+)</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-0 shadow text-center p-4">
              <FaSeedling size={50} className="text-info mx-auto mb-3" />
              <h5 className="fw-bold">ICAR JRF</h5>
              <h3 className="text-success mb-2">₹31,000</h3>
              <p className="text-muted small">Per Month (First 2 years)</p>
              <hr />
              <p className="small mb-0">Agriculture & allied</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-0 shadow text-center p-4">
              <FaHeartbeat size={50} className="text-warning mx-auto mb-3" />
              <h5 className="fw-bold">ICMR JRF</h5>
              <h3 className="text-success mb-2">₹31,000</h3>
              <p className="text-muted small">Per Month (First 2 years)</p>
              <hr />
              <p className="small mb-0">Medical Sciences</p>
            </div>
          </div>
        </div>
        <div className="alert alert-info text-center mt-4">
          <strong>Additional Benefits:</strong> HRA (House Rent Allowance), Contingency Grant (₹10,000-20,000/year), Book Grant, Conference Travel Support
        </div>
      </div>

      {/* CTA Section */}
      <div className="container py-3">
        <div className="card border-0 shadow-lg" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
          <div className="card-body text-white text-center p-5">
            <h2 className="fw-bold mb-3">Ready to Start Your Research Career?</h2>
            <p className="lead mb-4">
              Join our comprehensive training program and secure your fellowship in CSIR/UGC/ICAR/ICMR
            </p>
            <button className="btn btn-light btn-lg px-5 me-3">Enroll Now</button>
            <button className="btn btn-outline-light btn-lg px-5">Book Free Demo Class</button>
          </div>
        </div>
      </div>

    
    </div>
  );
};

export default ResearchAcademicPage;